import {Alert} from "inferno-bootstrap";
import {T} from "inferno-i18next";
import {Level} from "../../utils/types";

export function Notification(props: { level: Level, message: string, dismiss?: any }) {
	return (
		<div className="fixed-bottom pl-3 pr-3 pb-3 notification">
			<Alert color={props.level || Level.Info} onClose={props.dismiss} className="shadow">
				<T i18nKey={props.message}>X</T>
			</Alert>
		</div>
	);
}
